import { SmileTwoTone } from "@ant-design/icons";
import { Result } from "antd";
import React from "react";
import { PRIMARY_COLOR } from "../../utils";

const DownloadSuccess = () => {
  let application_number = window.sessionStorage.getItem("application_number");

  return (
    <div>
      <Result
        title="Application submitted"
        subTitle="You will receive an email shortly."
        icon={<SmileTwoTone twoToneColor={PRIMARY_COLOR} />}
        extra={
          <>
            <p>Application Number - {application_number}</p>
          </>
        }
      />
    </div>
  );
};

export default DownloadSuccess;
